import { MARK_EMAIL_AS_READ } from "../constants";
import Requests from "../requests";

const EmailService = {
    markEmailAsRead
}

async function markEmailAsRead({ account, thread_id, read = false }) {
    let response = await Requests.postWithAuth(MARK_EMAIL_AS_READ, {
        account,
        thread_id,
        read
    });

    return response;
}

export default EmailService;